import React from 'react'
import { AuthUserContext } from '../Session'
import { withFirebase } from '../Firebase'

import { BlancheLogoRed } from '../Icons'
import { LanguageSwitcher } from '../Navigation'

import BlancheLogoWhite from '../../imgs/white-logo.png'
import AppStoreImg from '../../imgs/appstore-dw-icon.png'
import GooglePlayImg from '../../imgs/google-play-dw-icon.png'

import { useTranslation } from 'react-i18next'

const ThankyouPage = () => {
  const { t } = useTranslation()

  return (
    <AuthUserContext.Consumer>
      {authUser =>
        <div className={authUser ? 'accountBox' : 'landingPage'}>
          {!authUser && (
            <div className='centerContent mobile_hide'>
              <div style={{ width: '100%' }}>
                <BlancheLogoRed className="logo" to={window.location.origin + '/payment'} />

                <LanguageSwitcher list={true} />
              </div>
            </div>
          )}

          <div className='sectionContent' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '350px', width: '540px', maxWidth: '100%' }}>
            <div>
              {!authUser && (
                <>
                  <a href={window.location.origin + '/payment'}>
                    <img src={BlancheLogoWhite} alt="" className="logo mobile_show" style={{ marginBottom: '40px' }} />
                  </a>

                  <div className="mobile_show">
                    <LanguageSwitcher list={true} />
                    <p></p>
                  </div>
                </>
              )}

              <h1 className='sectionTitle' style={{ fontSize: '2.2rem', marginBottom: '50px' }}>{t('thankyou_page_heading')}{/* <span style={{ fontFamily: 'arial' }}>!</span> */}</h1>

              {/* <p>{t('Välkommen till ett universum av romantiska äventyr, erotiska noveller och lekfulla guider som väcker din lust och kittlar dina begär')}</p> */}

              <h3 className='subHeading' style={{ marginBottom: '0', lineHeight: 'normal' }}>{t('Klicka nedan för att ladda ner appen')}</h3>

              <p style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>
                <a
                  href='https://play.google.com/store/apps/details?id=com.blanchestories.blanchestories&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                  className='icon'
                >
                  <img src={GooglePlayImg} alt="" style={{ width: '150px', maxWidth: '100%', height: '45px' }} />
                </a>
                <a
                  href='https://apps.apple.com/us/app/blanchestories/id1539883289?itsct=apps_box_badge&itscg=30200'
                  className='icon'
                >
                  <img src={AppStoreImg} alt="" style={{ width: '150px', maxWidth: '100%', height: '45px' }} />
                </a>
              </p>
            </div>
          </div>
        </div>
      }
    </AuthUserContext.Consumer>
  )
}

export default withFirebase(ThankyouPage)
